import React, { useCallback, useContext, useEffect, useState } from 'react';
import styles from './BannerHalfWidthPointsSimpleVariants.module.scss';
import ImagePoints from '../../Components/ImageComponent/ImagePoints';
import { imageWrapperWithButtonRefFunction, mergeArrays, sanitizeType } from '../../../../functions';
import ProductsCarousel from '../../../Products/ProductsCarousel';
import Lottie from 'lottie-react';
import { DataContext } from '../../../../views/pages/Root';

const TrendsBanner = ({ api, type }) => {
  const data = useContext(DataContext);
  const [animation, setAnimation] = useState();
  const productsList = mergeArrays(api?.attributes?.products, api?.attributes?.productsBorder);

  useEffect((_) => {
    if (!!api?.attributes?.bcgAnimationName) {
      setAnimation(!!data?.animations2?.length && data.animations2.find((prop) => prop.name == api.attributes.bcgAnimationName));
    }
  }, []);

  return (
    <section id={api?.id} className={`${styles.BannerHalfWidthPointsSimpleVariants} ${styles.BannerTrends}`}>
      {!!api?.attributes?.title && (
        <h2 className={styles.sectionTitle} data-aos="fade-right" data-aos-duration="1000" data-aos-easing="easy-in-out" data-aos-once="false">
          {api.attributes.title}
        </h2>
      )}
      <div className={`${styles.topContainer} ${sanitizeType(type, styles)}`}>
        <div className={styles.contentContainer}>
          {!!api?.attributes?.bcgAnimationName && (
            <figure className={styles.backgroundContainer}>
              {!!animation && <Lottie autoplay="true" animationData={animation?.value} loop={true} className={styles.animationOnImage}></Lottie>}
            </figure>
          )}
          {!!api?.attributes?.description && (
            <p className={styles.titleDescription} data-aos="fade-up" data-aos-duration="1000" data-aos-easing="easy-in-out" data-aos-once="false">
              {api.attributes.description}
            </p>
          )}
        </div>
        <div
          className={`${styles.imageContainer}`}
          data-aos="fade-up"
          // data-aos-delay="300"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          data-aos-once="false"
        >
          <div className={`${styles.imagePointsWrapper}`}>
            <ImagePoints properties={api.attributes} type="trends" />
          </div>
        </div>
      </div>
      {!!productsList && (
        <div className={styles.downContainer}>
          <ProductsCarousel productsList={productsList} type="trendProducts productSubcategory" />
        </div>
      )}
    </section>
  );
};

export default TrendsBanner;
